var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8105 20.4659C17.2155 20.8259 15.6938 21.4559 14.3555 22.3019",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6454 22.2839C28.3071 21.4379 26.7854 20.8079 25.1904 20.4479",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9891 31.068C35.6225 29.502 34.9808 28.008 34.1191 26.694",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86414 26.694C9.00247 28.008 8.36081 29.502 7.99414 31.068",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0949 35.1C29.1499 34.812 29.1682 34.506 29.1682 34.2C29.1682 30.294 25.9782 27.162 21.9999 27.162C18.0215 27.162 14.8315 30.294 14.8315 34.2C14.8315 34.506 14.8499 34.812 14.9049 35.1",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8101 20.466V16.2H25.1901V20.466",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6455 22.284L32.7072 19.2599L37.2172 23.688L34.1372 26.694",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9888 31.0679H40.3338V35.0999",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 35.0999V31.0679H8.01199",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86418 26.694L6.78418 23.688L11.2942 19.2599L14.3558 22.284",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2503 35.1H2.75033C1.74199 35.1 0.916992 34.29 0.916992 33.3V0.899963H43.0837V33.3C43.0837 34.29 42.2587 35.1 41.2503 35.1Z",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.916992 8.09998H43.0837",
    stroke: "#21AEFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 5.39998C6.92293 5.39998 7.33333 4.99703 7.33333 4.49998C7.33333 4.00292 6.92293 3.59998 6.41667 3.59998C5.91041 3.59998 5.5 4.00292 5.5 4.49998C5.5 4.99703 5.91041 5.39998 6.41667 5.39998Z",
    fill: "#21AEFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0837 5.39998C10.5899 5.39998 11.0003 4.99703 11.0003 4.49998C11.0003 4.00292 10.5899 3.59998 10.0837 3.59998C9.5774 3.59998 9.16699 4.00292 9.16699 4.49998C9.16699 4.99703 9.5774 5.39998 10.0837 5.39998Z",
    fill: "#21AEFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7507 5.39998C14.2569 5.39998 14.6673 4.99703 14.6673 4.49998C14.6673 4.00292 14.2569 3.59998 13.7507 3.59998C13.2444 3.59998 12.834 4.00292 12.834 4.49998C12.834 4.99703 13.2444 5.39998 13.7507 5.39998Z",
    fill: "#21AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlan);
export default __webpack_public_path__ + "static/media/upgrade-plan.e657cbaed9bc7c9cfecbe196e99e86d9.svg";
export { ForwardRef as ReactComponent };